import {
  UpdatePatientCaseStatusActionTypes,
  UPDATE_PATIENT_CASE_STATUS_FAIL,
  UPDATE_PATIENT_CASE_STATUS_LOADING,
  UPDATE_PATIENT_CASE_STATUS_SUCCESS,
  UpdatePatientCaseStatusState,
  UPDATE_PATIENT_CASE_STATUS_UPDATE_API_MSG,
  UPDATE_PATIENT_CASE_STATUS_UPDATE_API_RES,
} from "./ActionTypes";
import { UpdatePatientCaseStatusRes } from "./Model";

const initialStateGetPosts: UpdatePatientCaseStatusState = {
  loading: false,
  updatePatientCaseStatusRes: {} as UpdatePatientCaseStatusRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const updatePatientCaseStatusReducer = (
  state = initialStateGetPosts,
  action: UpdatePatientCaseStatusActionTypes
): UpdatePatientCaseStatusState => {
  switch (action.type) {
    case UPDATE_PATIENT_CASE_STATUS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case UPDATE_PATIENT_CASE_STATUS_SUCCESS:
      return {
        ...state,
        updatePatientCaseStatusRes: action.payload,
        successMsg: action.successMsg,
      };
    case UPDATE_PATIENT_CASE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        updatePatientCaseStatusRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case UPDATE_PATIENT_CASE_STATUS_UPDATE_API_MSG:
      return {
        ...state,
        loading: false,
        updatePatientCaseStatusRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case UPDATE_PATIENT_CASE_STATUS_UPDATE_API_RES:
      return {
        ...state,
        loading: false,
        updatePatientCaseStatusRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
